import {
  NBS_API_EMAIL_REGISTER_REQUEST,
  NBS_API_EMAIL_REGISTER_SUCCESS,
  NBS_API_EMAIL_REGISTER_FAILURE
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import { trackNewProfile } from '../../assets/helpers/utils';
import strings from '../../assets/localization';

function nbsApiEmailRegisterRequest (fromPage) {
  return {
    type: NBS_API_EMAIL_REGISTER_REQUEST,
    fromPage
  };
}
function nbsApiEmailRegisterSuccess (response) {
  return {
    type: NBS_API_EMAIL_REGISTER_SUCCESS,
    response
  };
}
function nbsApiEmailRegisterError (error) {
  return {
    type: NBS_API_EMAIL_REGISTER_FAILURE,
    error: error.cause || error
  };
}

export function nbsApiEmailRegister (data, fromPage) {
  const url = 'signup';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiEmailRegisterRequest(fromPage));
    return nbsApi(url, data)
      .then(response => {
        trackNewProfile(data.age);
        return dispatch(nbsApiEmailRegisterSuccess(response));
      })
      .catch(error => dispatch(nbsApiEmailRegisterError(error)));
  };
}
